import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:h-10 hidden md:block" }, null, -1)
const _hoisted_2 = { class: "relative flex-grow flex" }
const _hoisted_3 = { class: "flex pt-0 bg-white mx-auto max-w-[1280px] sm:px-4 md:px-8 2xl:px-16 w-full" }
const _hoisted_4 = { class: "flex-shrink-0 hidden pe-24 lg:block w-96 bg-red-0" }
const _hoisted_5 = { class: "flex flex-col md:w-[768px] mx-auto w-full" }

import NaviHeight from '@/components/Navigator/NaviHeight.vue'
import SpeciesFilter from '@/components/Serach/SpeciesFilter.vue';
import TopNavigator from '@/components/Navigator/TopNavigator.vue'
import Section9Footer from '@/components/Landing/Section9Footer.vue'
// import { useRouter } from 'vue-router';
// import ShowMorph from '@/components/Serach/ShowMorph.vue';
// import WritePost from '@/components/Serach/WritePost.vue';
  // const router = useRouter();
  // const goWrite = () => {
  //   router.push('search/write')
  // }

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopNavigator),
    _createVNode(NaviHeight),
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SpeciesFilter)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _createVNode(Section9Footer)
  ], 64))
}
}

})